import get from 'lodash.get';

import { emptyArray, emptyObject } from 'ui-components/default-props/empty';

export const selectIds = (state) => get(state, 'selectedOrderIds', emptyArray);
export const selectOutdatedIds = (state) => get(state, 'outdatedIds', emptyObject);
export const selectCount = (state) => get(selectIds(state), 'length');

export const selectAreAllOrdersSelected = (state) => get(state, 'allOrdersSelected', false);
